import { createFileRoute } from "@tanstack/react-router";
import NewsArticle from "@/pages/NewsArticle";
import { newsArticles } from "@/pages/Nieuws";

const DOMAIN = "https://dehusselapp.nl";

export const Route = createFileRoute("/nieuws/$slug")({
  head: ({ params }) => {
    const article = newsArticles.find((a) => a.slug === params.slug);
    const url = `${DOMAIN}/nieuws/${params.slug}`;
    if (!article) {
      return {
        meta: [
          { title: "Artikel niet gevonden | De Hussel App" },
          { name: "robots", content: "noindex" },
        ],
      };
    }
    const title = `${article.title} – De Hussel App Nieuws`;
    return {
      meta: [
        { title },
        { name: "description", content: article.excerpt },
        { property: "og:title", content: title },
        { property: "og:description", content: article.excerpt },
        { property: "og:type", content: "article" },
        { property: "og:url", content: url },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [{ rel: "canonical", href: url }],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "NewsArticle",
            headline: article.title,
            description: article.excerpt,
            datePublished: article.date.split("/").reverse().join("-"),
            url,
          }),
        },
      ],
    };
  },
  component: NewsArticle,
});
